import type { resolution } from "./definitions";

export const MIN_SCALE = 1;
export const MAX_SCALE = 3;

export const NOTIFICATIONS_TIMEOUT = 4000;
export const PARTICIPANT_MAX_HEIGHT = 160;
export const PARTICIPANT_MAX_WIDTH = 120;
export const PARTICIPANT_MAX_HEIGHT_MOBILE = 128;
export const PARTICIPANT_MAX_WIDTH_MOBILE = 90;

export const DEFAULT_RESOLUTION: resolution = "640x480";
export const DEFAULT_RESOLUTION_SHARE_SCREEN: resolution = "1280x720";
